performance.setResourceTimingBufferSize(5000)
performance.mark('application-start')

const [, language, , region] = window.locale_name
  .toLowerCase()
  .match(/^([a-z]+)([_-]([a-z]+))?$/)
const locale = region ? `${language}-${region.toUpperCase()}` : language

window.localeName = (() => {
  switch (locale) {
    case 'en':
      return 'en-GB'
    default:
      return locale
  }
})()
